
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Datakälla',
	'dataSourceId': 'ID',
	'dataSourceType': 'Typ',
	'dataSourceName': 'Namn',
	'dataSourcePath': 'Sökväg',
	'showInfoForAll': 'Visa varaktighet för alla visualiseringar',
	'hideInfoForAll': 'Dölj varaktighet för alla visualiseringar',
	'showPerformanceDetails': 'Kör om alla widgetar för att inkludera prestandadetaljer',
	'slotMappingField': 'Platsavbildningar',
	'slotDataMapping': 'Avbildning',
	'slotID': 'ID',
	'slotCaption': 'Objekttext',
	'slotMandatory': 'Obligatoriskt',
	'slotIsMandatory': 'Ja',
	'slotIsNotMandatory': 'Nej',
	'infoNotAvailable': 'Ej tillgänglig',
	'performanceSection': 'Prestanda',
	'durationField': 'Varaktighet',
	'singleQueryTime': 'Serverfråga (ms)',
	'multipleQueryTime': 'Serverfråga %{name} (ms)',
	'liveWidgetTotalTime': 'Totalt (ms)',
	'renderTimeNotAvailable': 'Ej tillgängligt',
	'renderInProgress': '(pågående)',
	'interactToTriggerQuery': 'Interagera med widget för att utlösa en fråga',
	'fetchQuery': 'Hämta fråga',
	'showSQLMDX': 'Visa SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Frågeinformation',
	'queryInfoNotAvailable': 'Frågeinformation är inte tillgänglig',
	'query': 'Fråga',
	'copy': 'Kopiera',
	'close': 'Stäng'
});
